export default __webpack_public_path__ + "static/media/guia.0fb1cda7.svg";